/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Expanded/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EntryType from './EntryType/index'
import Notes from './Notes/index'
import Payment from './Payment/index'
import Point from './Point/index'
import React from 'react'
import Receivable from './Receivable/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Expanded({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/Expanded"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Expanded.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2dncGL': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Z2dncGL': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-3-Z2dncGL': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-4-Z2dncGL': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<Point
  viewPath={`${viewPath}/Point`}
/>
<div
  data-testid="Expanded.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-5-Z2dncGL': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-6-Z2dncGL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<EntryType
  viewPath={`${viewPath}/EntryType`}
/>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
<Receivable
  viewPath={`${viewPath}/Receivable`}
/>
<Payment
  viewPath={`${viewPath}/Payment`}
/>
</div>
</div>
{children}
</React.Fragment>)
}